import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import Translate from "../../../i18n/Translate";

import dataFiscalQRImg from "../../../assets/images/static/DataFIscal-QR.png";
import bureauVeritasCertImg from "../../../assets/images/static/bureau-veritas-certification@2x.png";
import iso9001CertificateImg from "../../../assets/images/static/iso-9001-certificate.png";

const AFIP_URL =
  "https://servicios1.afip.gov.ar/clavefiscal/qr/mobilePublicInfo.aspx?req=e1ttZXRob2Q9Z2V0UHVibGljSW5mb11bcGVyc29uYT0zMDcwODQ3NDI4OV1bdGlwb2RvbWljaWxpbz0wXVtzZWN1ZW5jaWE9MF1bdXJsPWh0dHA6Ly93d3cudG93ZXJ0cmF2ZWwuY29tLmFyL119";

const DataFiscalISOSection = ({ language }) => {
  const { t } = useTranslation();
  const [showCertificate, setShowCertificate] = useState(false);

  const langKey =
    language && language.length >= 2
      ? language.substring(0, 2).toLowerCase()
      : "es";
  const timestamp = new Date().getTime();
  const pdfDownloadUrl = `https://www.towertravel.com.ar/incoming/upfiles/pdf/politicacalidad/${langKey}/towertravel.pdf?t=${timestamp}`;

  useEffect(() => {
    if (!showCertificate) return undefined;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setShowCertificate(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "auto";
    };
  }, [showCertificate]);

  const certificateModal = showCertificate
    ? createPortal(
        <div
          className="certificate-modal"
          onClick={() => setShowCertificate(false)}
          role="dialog"
          aria-modal="true"
          aria-label={t("footer.column5.certAlt")}
        >
          <div
            className="certificate-modal__content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="certificate-modal__close"
              onClick={() => setShowCertificate(false)}
              aria-label={t("footer.column5.closeAria")}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>

            <img
              src={iso9001CertificateImg}
              alt={t("footer.column5.certAlt")}
              onContextMenu={(e) => e.preventDefault()}
              onDragStart={(e) => e.preventDefault()}
            />
          </div>
        </div>,
        document.body
      )
    : null;

  return (
    <>
      <div className="data-fiscal">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={AFIP_URL}
          title="Ver constancia de AFIP"
        >
          <img src={dataFiscalQRImg} alt={t("footer.column5.qrAlt")} />
        </a>

        <div className="data-fiscal__text">
          <p className="data-fiscal__title">
            <Translate langkey="footer.column5.title" />
          </p>
          <p>
            <Translate langkey="footer.column5.copy" />
          </p>
          <p>
            <Translate langkey="footer.column5.copy2" />
          </p>
        </div>
      </div>

      <div className="certs-quality">
        <div className="bureau-veritas-cert">
          <img
            src={bureauVeritasCertImg}
            alt={t("footer.column5.bureauAlt")}
          />
        </div>

        <p className="certs-quality__action">
          <button
            type="button"
            className="btn-ver-certificado"
            onClick={() => setShowCertificate(true)}
          >
            <Translate langkey="footer.column5.copy3" />
          </button>
        </p>

        <p className="certs-quality__scope">
          <strong>
            <Translate langkey="footer.column5.copy7" />
          </strong>{" "}
          <Translate langkey="footer.column5.copy4" />
        </p>

        <p className="certs-quality__email">
          <a href={`mailto:${t("footer.column5.copy5")}`}>
            <Translate langkey="footer.column5.copy5" />
          </a>
        </p>

        <a
          className="btn-descargar-politica"
          href={pdfDownloadUrl}
          target="_blank"
          rel="noopener noreferrer"
          download
        >
          <Translate langkey="footer.column5.copy6" />
        </a>
      </div>

      {certificateModal}
    </>
  );
};

export default DataFiscalISOSection;
